import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
// console.log("dasda",BACKEND_URL)
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const setAuthToken = (token) => {
  if (token) {
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    localStorage.setItem("lr_token", token);
  } else {
    delete api.defaults.headers.common["Authorization"];
    localStorage.removeItem("lr_token");
  }
};

const stored = localStorage.getItem("lr_token");
if (stored) api.defaults.headers.common["Authorization"] = `Bearer ${stored}`;
